import { get } from "lodash";
import { convertHexToRGB } from "../../utils";

const styles = (theme) => ({
  flex: {
    display: "flex",
    alignItems: "center",
  },
  additionalText: {
    backgroundColor: convertHexToRGB(get(theme, 'color.gray'), 0.5),
    borderRadius: '8px',
    padding: "5px 14px",
    marginLeft: 10,
    fontSize: "13px",
  },
  bgColorBox: {
    width:25,
    height: 20,
    borderRadius: 3,
    marginLeft: -4,
    border: `1px solid ${get(theme, 'color.gray')}`,
    cursor: "pointer",
  },
  fieldContainer: {
    position: 'relative',
    height: '60px',
    marginTop: 5,
    marginBottom: 5,
  },
  label: {
    width: 201,
    height: 20,
    fontWeight: 400,
  },
  sketchPicker: {
    position: "absolute",
    top: 46,
    left: 212,
    zIndex: 1000,
  },
});

export default styles;